// Internal
import { HorizontalDragPanel } from "../../drag-handle/drag-panel";
import { Sidebar } from "../../sidebar/sidebar";

// CSS
import "./navigation-sidebar.css";

function NavigationSidebar(props) {
    if (!props.Sidebar) {
        return null;
    }

    return (
        <div className={`eone-ui-navigation-sidebar-horizontal-drag-panel-container`}>
            <HorizontalDragPanel InitialWidth={400} MinWidth={300} SetIsDragging={props.SetIsDragging}>
                <Sidebar
                    HideClose
                    HideHeader={props.Sidebar.Title ? false : true}
                    HeaderTitle={props.Sidebar.Title} >
                    {props.Sidebar.Body}
                </Sidebar>
            </HorizontalDragPanel >
        </div>
    );
}

export { NavigationSidebar };
